var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKzt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3642_19872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3041 20.2173H8.69531C8.69531 21.7781 10.0548 23.0434 11.6155 23.0434H11.5214C11.5214 24.6042 12.7866 25.8695 14.3475 25.8695C14.3475 27.4303 15.6127 28.6956 17.1736 28.6956H22.8258C24.3866 28.6956 25.6519 27.4303 25.6519 25.8695C27.2127 25.8695 28.478 24.6042 28.478 23.0434H28.3839C29.9445 23.0434 31.3041 21.7781 31.3041 20.2173Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.826 16.5217C27.826 20.8439 24.3221 24.3478 19.9999 24.3478C15.6777 24.3478 12.1738 20.8439 12.1738 16.5217",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.977 16.5214L23.5344 17.6704L24.8351 20.0361L22.1827 19.5286L21.8466 22.208L19.9992 20.2373L18.1517 22.208L17.8157 19.5286L15.1634 20.0359L16.464 17.6704L14.0215 16.5214L16.4641 15.3725L15.1634 13.007L17.8156 13.5143L18.1518 10.835L19.9992 12.8057L21.8467 10.835L22.1827 13.5143L24.8352 13.007L23.5345 15.3726L25.977 16.5214Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3642_19872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKzt);
export default __webpack_public_path__ + "static/media/KZT.0f8cfa5a3fd826dbbc5199deace8c48c.svg";
export { ForwardRef as ReactComponent };